import { Spinner } from "@/components/ui/spinner";
import { VStack } from "@/components/ui/vstack";
import { useSession } from "@/utils/session.ctx";
import { useLocalSearchParams, useRouter } from "expo-router";
import { useEffect } from "react";

export default function RedirectCallback() {
  const router = useRouter();
  const { to } = useLocalSearchParams<{ to: string }>();

  useEffect(() => {
    router.replace(to as any);
  }, []);

  return (
    <VStack className="gap-6">
      <Spinner size="large" />
    </VStack>
  );
}
